<template>
    <div class="DirectManagerBlock">
        <p v-if="name" class="mb-2">
            {{ name }}
        </p>

        <CButton v-if="url" class="!px-4 font-medium" :href="url" icon="linkedin" target="_blank" variant="linkedin">
            {{ $t('directManagerBlock.linkedInButton', lang) }}
        </CButton>
    </div>
</template>

<script setup lang="ts">
import CButton from '@/components/ui/CButton.vue'

defineProps({
    name: {
        type: String,
        default: ''
    },
    url: {
        type: String,
        default: ''
    },
    lang: {
        type: String,
        default: 'sk'
    }
})
</script>
